// PAQUETES
import { useEffect, useState } from "react";
import {Routes, Route, Outlet, Navigate, useLocation } from 'react-router-dom';
import axios from "axios";
import { eventoLoginSuccess, eventoLoginFailed } from "./funcionesDatos/eventoPropio";
// PARTIALS
import HeaderGlobal from "./partials/HeaderGlobal";
import CabeceraUsuarioVendedor from "./partials/cabeceraUsuarioVendedor";
import Footer from "./partials/footer"; 
import FooterSimple from "./partials/footerSimple";
import CabeceraAdmin from "./partials/cabeceraAdmin";
import SidebarAdmin from "./partials/sidebarAdmin";
// GLOBAL
import Home from "./paginas/global/Home";
import VerServicio from "./paginas/global/verServicio";
import Privacidad from "./paginas/global/Privacidad";
import Devolucion from "./paginas/global/Devolucion";
import Cookies from "./paginas/global/Cookies";
import Terminos from "./paginas/global/Terminos";
import Busqueda from "./paginas/global/Busqueda";
import Categorias from "./paginas/global/Categorias";
import DescargaApp from "./paginas/global/DescargaApp";
import UsuarioServicios from "./paginas/global/UsuarioServicios";
import Soporte from "./paginas/global/Soporte";
import Conversacion from "./paginas/administrador/conversacion";
import Links from "./paginas/global/Links";
import ComoFunciona from "./paginas/global/ComoFunciona";
// GLOBAL PAGOS
import Reserva from "./paginas/global/pagos/Reserva";
import Pago from "./paginas/global/pagos/pago";
import RespuestaPago from "./paginas/global/pagos/respuestaPago";
import Preguntas from "./paginas/global/Preguntas";
import Mantenimiento from "./paginas/sesion/mantenimiento";
// SESION
import InicioSesion from "./paginas/sesion/Iniciosesion";
import Registro from "./paginas/sesion/registrar";
import EliminarDatos from "./paginas/sesion/eliminarDatos";
import CallbackDidit from "./paginas/usuario/vendedor/callbackDidit";
import Referido from "./paginas/sesion/referido";
import BannerDescargarApp from "./componentesEspeciales/bannerDescargarApp";
import BannerPrimeraCompra from "./componentesEspeciales/bannerPrimeraCompra";
import GoogleOneTapGlobal from "./componentesEspeciales/googleOneTapGlobal";
// ALERTAS
import Alerta from "./paginas/alertas/alerta";
import AlertaErrorInicioSesion from "./paginas/alertas/alertaErrorInicioSesion";
// USUARIO
import Valoraciones from "./paginas/usuario/valoraciones";
// USUARIO COMPRADOR
import MiCuentaComprador from "./paginas/usuario/comprador/miCuentaComprador";
import Favoritos from "./paginas/usuario/comprador/favoritos";
import PagosComprador from "./paginas/usuario/comprador/pagosComprador";
import PagoIndividualComprador from "./paginas/usuario/comprador/pagoIndividual";
import ReservasComprador from "./paginas/usuario/comprador/reservasComprador";
import ReservaIndividualComprador from "./paginas/usuario/comprador/reservaIndividualComprador";
import NotificacionesComprador from "./paginas/usuario/comprador/notificacionesComprador";
// USUARIO VENDEDOR
import MiCuentaVendedor from "./paginas/usuario/vendedor/miCuentaVendedor";
import Dasboard from "./paginas/usuario/vendedor/dasboard";
import CrearEditarServicio from "./paginas/usuario/vendedor/crearEditarServicio";
import MisServicios from "./paginas/usuario/vendedor/misServicios";
import ReservasVendedor from "./paginas/usuario/vendedor/reservasVendedor";
import AgendaVendedor from "./paginas/usuario/vendedor/agendaVendedor";
import ReservaIndividual from "./paginas/usuario/vendedor/reservaIndividual";
import PagosVendedor from "./paginas/usuario/vendedor/pagosVendedor";
import PagoIndividual from "./paginas/usuario/vendedor/pagoIndividual";
import NotificacionesVendedor from "./paginas/usuario/vendedor/notificacionesVendedor";
import PreguntasVendedor from "./paginas/usuario/vendedor/preguntasVendedor";
// ADMIN
import DashboardAdmin from "./paginas/administrador/dashboardAdmin";
import Desembolsos from "./paginas/administrador/desembolsos";
import DesembolsoIndividual from "./paginas/administrador/desembolsoIndividual";
import ConciliacionWompi from "./paginas/administrador/conciliacionWompi";
import SoporteAdmin from "./paginas/administrador/soporteAdmin";
import MiCuentaAdmin from "./paginas/administrador/miCuenta";
import RegistrarAdministrador from "./paginas/administrador/RegistrarAdministrador";
import Usuarios from "./paginas/administrador/usuarios";
import UsuarioIndividual from "./paginas/administrador/usuarioIndividual";
import ReservaAdminIndividual from "./paginas/administrador/reservaIndividual";
import ReservasAdmin from "./paginas/administrador/reservas";
import ServiciosAdmin from "./paginas/administrador/servicios";
import ServicioAdminIndividual from "./paginas/administrador/servicioIndividual";
import ServiciosDeUsuario from "./paginas/administrador/serviciosDeUsuario";
import ServiciosPorCategoria from "./paginas/administrador/serviciosPorCategoria";
import ServicioIndividualCate from "./paginas/administrador/servicioIndividualCate";
import ServiciosPorUsuario from "./paginas/administrador/serviciosPorUsuario";
import Busquedas from "./paginas/administrador/busquedas";
import ReservasPorUsuario from "./paginas/administrador/reservasPorUsuario";
import ReportesPorUsuarios from "./paginas/administrador/reportesPorUsuarios";
import ReportesPorServicios from "./paginas/administrador/reportesPorServicios";
import ReportesPorReservas from "./paginas/administrador/reportesPorReservas";
import ReportesPagos from "./paginas/administrador/reportesPagos";
import PagosRecibidos from "./paginas/administrador/pagosRecibidos";
import Reclamos from "./paginas/administrador/reclamos";
import Resenas from "./paginas/administrador/resenas";
import ReclamoIndividual from "./paginas/administrador/reclamoIndividual";
import PagoAdminIndividual from "./paginas/administrador/pagoIndividual";
// FUNCIONES
import { solicitarYGuardarUbicacion } from "./funcionesDatos/solicitarUbicacion";

 

// uuid liviano para identificar la sesión del visitante en localStorage (sin librerías nuevas)
function obtenerIdSesionVisitante() {
    const CLAVE = "zervicy_id_sesion";
    try {
        let id = localStorage.getItem(CLAVE);
        if (!id) {
            id = (typeof crypto !== "undefined" && crypto.randomUUID) ? crypto.randomUUID() : `sesion-${Date.now()}-${Math.random().toString(16).slice(2)}`;
            localStorage.setItem(CLAVE, id);
        }
        return id;
    } catch (e) {
        // localStorage no disponible (modo privado, etc.) — sesión de un solo uso
        return `sesion-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }
}

function AnalyticsTracker({ usuario }) {
    const location = useLocation();

    // Resultado del login por Google (flujo de redirect completo, ver sincronizarGoogle.jsx y
    // backend/routes/registroInicio.js): el backend anexa ?loginEvento=exitoso|fallido&metodo=google
    // a la URL de destino porque no hay forma de correr JS en el momento exacto del resultado.
    // Lo leemos una vez al montar y limpiamos la URL para que un refresh no dispare el evento de nuevo.
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const loginEvento = params.get("loginEvento");
        if (!loginEvento) return;

        const metodo = params.get("metodo") || "google";
        if (loginEvento === "exitoso") {
            eventoLoginSuccess({ metodo, usuarioId: usuario?.idUsuario });
        } else if (loginEvento === "fallido") {
            eventoLoginFailed({ metodo, razon: "google_auth_failed" });
        }

        params.delete("loginEvento");
        params.delete("metodo");
        const query = params.toString();
        window.history.replaceState(null, "", location.pathname + (query ? `?${query}` : ""));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search]);

    useEffect(() => {
        const rutasExcluidas = ["/vendedor", "/usuario", "/administrador", "/administracion", "/admin"];
        const rutaActual = location.pathname;

        const excluida = rutasExcluidas.some((ruta) => rutaActual.startsWith(ruta));
        if (excluida) return;

        // GOOGLE ANALYTICS
        if (typeof window.gtag === "function") {
            window.gtag("event", "page_view", {
                page_title: document.title,
                page_location: window.location.href,
                page_path: location.pathname + location.search,
            });
        }

        // ejecutamos pixel facebook
        if (typeof window.fbq === "function") {
            window.fbq("track", "PageView");
        }

        // DEBUG
        // console.log("GA page_view:", location.pathname + location.search);
    }, [location]);

    // HEARTBEAT DE PRESENCIA: ping cada 60s mientras el visitante navega CUALQUIER parte del sitio
    // (público, cuenta de comprador, panel de vendedor). Solo excluimos /admin: ahí solo entra
    // nuestro staff viendo el dashboard, no son "usuarios activos" reales de la plataforma.
    // Nota: usa su propia lista de exclusión, distinta de la de GA/FB de arriba (esa sí debe
    // excluir /vendedor y /usuario para no ensuciar la analítica de marketing).
    useEffect(() => {
        const rutasExcluidasHeartbeat = ["/administrador", "/administracion", "/admin"];
        const excluida = rutasExcluidasHeartbeat.some((ruta) => location.pathname.startsWith(ruta));
        if (excluida) return;

        const idSesion = obtenerIdSesionVisitante();

        const enviarPing = () => {
            axios.post("/marcar-actividad", { params: { idSesion, idUsuario: usuario?.idUsuario || "", pagina: location.pathname, origen: "web" } })
                .catch(() => {}); // si falla, no afecta la navegación del visitante
        };

        enviarPing();
        const intervalo = setInterval(enviarPing, 60000);
        return () => clearInterval(intervalo);
    }, [location.pathname, usuario]);

    return null;
}

function Direccionamiento(){

    const [usuario, setUsuario] = useState(null);
    const [cargandoUsuario, setCargandoUsuario] = useState(true);
    const [mantenimiento, setMantenimiento] = useState(false);
    const [categorias, setCategorias] = useState([]);
    const [subCateg, setSubCateg] = useState([]);
    const [entornoApp, setEntornoApp] = useState("");
    const [ahoraServidor, setAhoraServidor] = useState(null);

    // Verificamos sesión UNA SOLA VEZ para toda la app (evita doble solicitud por página)
    useEffect(() => {
        (async () => {
            try {
                // OBTENER EL ENTORNO
                const respuesta = await axios.post("/obtener-entorno");
                const { entorno } = respuesta.data; // LOCAL, DESARROLLO, PRODUCCION
                setEntornoApp(entorno || "");

                // OBTENER AHORA DESDE EL BACKEND
                const resAhora = await axios.post("/obtener-ahora");
                setAhoraServidor(resAhora?.data?.ahora || null);

                // OBTENER VARIABLE DE MANTENIMIENTO
                const resMantenimiento = await axios.post("/obtener-mantenimiento");
                setMantenimiento(Boolean(resMantenimiento?.data?.mantenimiento));

                // OBTENER CATEGORÍAS UNA SOLA VEZ PARA TODA LA APP
                const obtenerCategorias = await axios.post("/obtener-categorias");
                if (obtenerCategorias.status === 200) {
                    setCategorias(obtenerCategorias.data.categorias || []);
                    setSubCateg(obtenerCategorias.data.subcategorias || []);
                }

                setCargandoUsuario(true);
                const res = await axios.get("/verificar-token", { withCredentials: true });
                const usuarioEncontrado = res?.data?.usuario || null;
                setUsuario(usuarioEncontrado);
                //console.log("usuario encontrado: ", usuarioEncontrado.ubicacionActual.permiso);
                // SI YA EXISTE EL USUARIO, entonces solicitar la ubicación.
                if (usuarioEncontrado?.ubicacionActual?.permiso === "pendiente") { console.log("entro a funcion"); solicitarYGuardarUbicacion(usuarioEncontrado); }
            }
            catch (err) { setUsuario(null); }
            finally { setCargandoUsuario(false); }
        })();
    }, []);

    // 
    const mostrarAhoraPruebas = entornoApp === "LOCAL" || entornoApp === "DESARROLLO";

    function formatearAhoraServidor(fecha) {
        if (!fecha) return "";

        const fechaObj = new Date(fecha);
        if (Number.isNaN(fechaObj.getTime())) return "";

        return fechaObj.toLocaleString("es-CO", {
            dateStyle: "medium",
            timeStyle: "medium",
            timeZone: "America/Bogota",
        });
    }

    function IndicadorAhoraPruebas() {
        if (!mostrarAhoraPruebas || !ahoraServidor) return null;

        return (
            <div style={{ position: "fixed", top: 8, left: 8, zIndex: 99999, background: "var(--azul-logo-fondo)", color: "var(--blanco)", borderRadius: "999px", padding: "6px 10px", fontSize: "12px", fontWeight: 600, boxShadow: "0 8px 24px rgba(var(--negro-rgb),0.18)", }} >
                <i className="bi bi-clock me-1"></i>
                {entornoApp}: {formatearAhoraServidor(ahoraServidor)}
            </div>
        );
    }

    function esRolAdministrativo(usuarioActual) {
        const rolesAdmin = ["Administrador", "SuperAdmin", "Soporte", "Moderador", "Contador"];
        return rolesAdmin.includes(usuarioActual?.tipo);
    }

    function BotonWhatsappSoporte() {
        const numeroSoporte = "573189859423";
        const mensaje = encodeURIComponent("Hola, necesito ayuda con Zervicy");
        const urlWhatsapp = `https://wa.me/${numeroSoporte}?text=${mensaje}`;

        return (
            <a
                href={urlWhatsapp}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Contactar soporte por WhatsApp"
                title="Soporte por WhatsApp"
                style={{
                    position: "fixed",
                    right: "18px",
                    bottom: "18px",
                    width: "58px",
                    height: "58px",
                    borderRadius: "50%",
                    background: "var(--verde-whatsapp)",
                    color: "var(--blanco)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "30px",
                    zIndex: 9999,
                    boxShadow: "0 12px 28px rgba(var(--negro-rgb), 0.22)",
                    textDecoration: "none",
                }}
            >
                <i className="bi bi-whatsapp"></i>
            </a>
        );
    }





    ///////////////////////////////
    // PLANTILLAS
    ///////////////////////////////
    function PlantillaGlobal() {
        return (
        <div>
            <BannerPrimeraCompra usuario={usuario} />
            <IndicadorAhoraPruebas />
            <HeaderGlobal usuario={usuario} cargandoUsuario={cargandoUsuario} setUsuario={setUsuario} categorias={categorias} subcategorias={subCateg}/>
            <BannerDescargarApp />
                <Outlet context={{ usuario, cargandoUsuario, setUsuario, entornoApp, ahoraServidor }} />
            <Footer usuario={usuario} setUsuario={setUsuario} />
            <BotonWhatsappSoporte />
        </div>
        )
    }


    function PlantillaVendedor() {
        return (
        <div>
            <IndicadorAhoraPruebas />
            <CabeceraUsuarioVendedor usuario={usuario} cargandoUsuario={cargandoUsuario} setUsuario={setUsuario} />
                <Outlet context={{ usuario, cargandoUsuario, setUsuario, entornoApp, ahoraServidor }} />
            <FooterSimple />
            <BotonWhatsappSoporte />
        </div>
        )
    }

    function PlantillaAdministrador() {
        return (
        <div>
            <IndicadorAhoraPruebas />
            <CabeceraAdmin />

            <div className="container-fluid">
                <div className="row">
                    <SidebarAdmin usuario={usuario} />

                    <main className="col-md-10 ms-sm-auto col-lg-10 px-md-4">
                        <Outlet context={{ usuario, cargandoUsuario, setUsuario, entornoApp, ahoraServidor }} />
                    </main>
                </div>
            </div>

            <FooterSimple />
        </div>
        )
    }


    function PlantillaSesion(){
        return(
            <div>
                <IndicadorAhoraPruebas />
                <BannerDescargarApp />
                <Outlet context={{ usuario, cargandoUsuario, setUsuario, entornoApp, ahoraServidor }} />
                <BotonWhatsappSoporte />
            </div>
        )
    }


    function PlantillaMantenimiento(){
          return(
            <div>
                <IndicadorAhoraPruebas />
                <Outlet context={{ entornoApp, ahoraServidor }} />
                <BotonWhatsappSoporte />
            </div>
        )
    }








    ///////////////////////////////
    // RUTAS
    ///////////////////////////////

    // Protege la zona global del comprador/publica.
    // Si un vendedor intenta entrar manualmente a la zona global (por ejemplo '/'),
    // NO se le cierra la sesión: simplemente se redirige a su dashboard.
    function RutaZonaGlobalComprador({ children }) {
        if (cargandoUsuario) return null;

        if (!usuario) return children;

        if (esRolAdministrativo(usuario)) {
            return <Navigate to="/admin" replace />;
        }

        return usuario.modo === "Vendedor"
            ? <Navigate to="/vendedor" replace />
            : children;
    }

    // Protege toda la zona del vendedor.
    // Si no hay sesión, redirige a iniciar sesión.
    // Si un comprador intenta entrar manualmente, no se le cierra la sesión:
    // se redirige al home del comprador.
    function RutaSoloVendedor({ children }) {
        if (cargandoUsuario) return null;

        if (!usuario) { return <Navigate to="/iniciar-sesion" replace />; }

        return usuario.modo === "Vendedor"
            ? children
            : <Navigate to="/" replace />;
    }

    // Protege toda la zona de administración.
    // Si no hay sesión, redirige a iniciar sesión.
    // Si el usuario no tiene un rol administrativo, lo redirige según su modo normal.
    function RutaSoloAdministrador({ children }) {
        if (cargandoUsuario) return null;

        if (!usuario) { return <Navigate to="/iniciar-sesion" replace />; }

        if (esRolAdministrativo(usuario)) return children;

        return usuario?.modo === "Vendedor"
            ? <Navigate to="/vendedor" replace />
            : <Navigate to="/" replace />;
    }

    function RutaSoloSuperAdmin({ children }) {
        if (cargandoUsuario) return null;
        if (!usuario) return <Navigate to="/iniciar-sesion" replace />;
        if (usuario.tipo === "SuperAdmin") return children;
        return <Navigate to="/admin" replace />;
    }

    // Bloquea a Soporte de rutas de pagos y reportes — redirige al dashboard admin.
    function RutaNoSoporte({ children }) {
        if (cargandoUsuario) return null;
        if (!usuario) return <Navigate to="/iniciar-sesion" replace />;
        if (usuario.tipo === "Soporte") return <Navigate to="/admin" replace />;
        return children;
    }

    if (mantenimiento===true) {
        return (
            <Routes>
                <Route path="/" element={<PlantillaMantenimiento />}>
                    <Route index element={<Mantenimiento />} />
                    <Route path="/preguntas" element={<Preguntas />} />
                    <Route path="/terminos" element={<Terminos />} />
                    <Route path="/politica-devolucion" element={<Devolucion />} />
                    <Route path="/politica-privacidad" element={<Privacidad />} />
                    <Route path="/politica-cookies" element={<Cookies />} />
                    <Route path="/eliminar-datos" element={<EliminarDatos />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                    <Route path="/descargar-beta"  element={<DescargaApp />}/>
                </Route>
            </Routes>
        );
    }

    return(
        <>
            <AnalyticsTracker usuario={usuario} />
            <GoogleOneTapGlobal usuario={usuario} cargandoUsuario={cargandoUsuario} setUsuario={setUsuario} />

            <Routes>
            {/* SESIÓN y ALERTA*/}
            <Route path="/" element={<PlantillaSesion />}>
                <Route path="/iniciar-sesion" element={<InicioSesion />} />
                <Route path="/registrar"      element={<Registro />} />
                <Route path="/referido"       element={<Referido />} /> 
                <Route path="/:referidoPor/te-invito-a-zervicy" element={<Referido />} />
                <Route path="/eliminar-datos" element={<EliminarDatos />} />
                {/* ALERTA */}
                <Route path="/alerta"              element={<Alerta />} />
                <Route path="/error-inicio-google" element={<AlertaErrorInicioSesion />} />
                {/* DESCARGA BETA */}
                <Route path="/descargar-beta"  element={<DescargaApp />}/>
                {/* CALLBACK DIDIT */}
                <Route path="/callback-didit"  element={<CallbackDidit />}/>
                {/* PÁGINA DE USERNAME SERVICIOS USAURIO */}
                <Route path="/:username"  element={<UsuarioServicios />}/>
            </Route>
            
            {/* ZONA GLOBAL COMPRADOR / PÚBLICA */}
            <Route path="/" element={<RutaZonaGlobalComprador><PlantillaGlobal /></RutaZonaGlobalComprador>}>
                <Route index element={<Home />}/>
                <Route path="/preguntas"           element={<Preguntas />}/>
                <Route path="/terminos"            element={<Terminos />}/>
                <Route path="/politica-devolucion" element={<Devolucion />}/>
                <Route path="/politica-privacidad" element={<Privacidad />}/>
                <Route path="/politica-cookies"    element={<Cookies />}/>
                <Route path="/servicio/:nombreYid" element={<VerServicio />}/>
                <Route path="/busqueda"            element={<Busqueda />}/>
                <Route path="/categoria/:categoria" element={<Categorias />}/>
                <Route path="/soporte"             element={<Soporte />}/>
                <Route path="/links"               element={<Links />}/>
                <Route path="/como-funciona"       element={<ComoFunciona />}/>
                
                {/* PAGOS */}
                <Route path="/reserva"             element={<Reserva />}/>
                <Route path="/pago"                element={<Pago />}/>
                <Route path="/respuesta-pago"      element={<RespuestaPago />}/>
                {/* USUARIO COMPRADOR */}
                <Route path="/usuario/favoritos"           element={<Favoritos />}/>
                <Route path="/usuario/mi-cuenta"           element={<MiCuentaComprador />}/>
                <Route path="/usuario/pagos"               element={<PagosComprador />}/>
                <Route path="/usuario/pago-individual"     element={<PagoIndividualComprador />}/>
                <Route path="/usuario/reservas"            element={<ReservasComprador />}/>
                <Route path="/usuario/ver-reserva"         element={<ReservaIndividualComprador />}/>
                <Route path="/usuario/notificaciones"      element={<NotificacionesComprador />}/>
            </Route>
           
            {/* ZONA VENDEDOR */}
            <Route path="/vendedor" element={<RutaSoloVendedor><PlantillaVendedor /></RutaSoloVendedor>}>
                <Route index element={<Dasboard />}/>
                <Route path="mi-cuenta"             element={<MiCuentaVendedor />} />
                <Route path="servicios"             element={<MisServicios />} />
                <Route path="preguntas"             element={<PreguntasVendedor />} />
                <Route path="crear-editar-servicio" element={<CrearEditarServicio />} />
                <Route path="gestionar-reservas"    element={<ReservasVendedor />} />
                <Route path="reserva"               element={<ReservaIndividual />} />
                <Route path="agenda"                element={<AgendaVendedor />} />
                <Route path="gestionar-pagos"       element={<PagosVendedor />} />
                <Route path="pago"                  element={<PagoIndividual />} />
                <Route path="notificaciones"        element={<NotificacionesVendedor />} />
            </Route>


            {/* ZONA ADMINISTRACION */}
            <Route path="/admin" element={<RutaSoloAdministrador><PlantillaAdministrador /></RutaSoloAdministrador>}>
                <Route index element={<DashboardAdmin />}/>
                <Route path="pagos"              element={<RutaNoSoporte><PagosRecibidos /></RutaNoSoporte>} />
                <Route path="pago"               element={<RutaNoSoporte><PagoAdminIndividual /></RutaNoSoporte>} />
                <Route path="desembolsos"        element={<RutaNoSoporte><Desembolsos /></RutaNoSoporte>} />
                <Route path="ver-desembolso"     element={<RutaNoSoporte><DesembolsoIndividual /></RutaNoSoporte>} />
                <Route path="conciliacion-wompi" element={<RutaNoSoporte><ConciliacionWompi /></RutaNoSoporte>} />
                <Route path="soporte" element={<SoporteAdmin />} />
                <Route path="conversacion" element={<Conversacion />} />
                <Route path="usuarios" element={<Usuarios />} />
                <Route path="usuario" element={<UsuarioIndividual />} />
                <Route path="reservas" element={<ReservasAdmin />} />
                <Route path="reservas-por-usuario" element={<ReservasPorUsuario />} />
                <Route path="reserva-admin" element={<ReservaAdminIndividual />} />
                <Route path="servicios" element={<ServiciosAdmin />} />
                <Route path="servicio" element={<ServicioAdminIndividual />} />
                <Route path="servicios-por-usuarios" element={<ServiciosPorUsuario />} />
                <Route path="servicios-usuario" element={<ServiciosDeUsuario />} />
                <Route path="categorias-servicios" element={<ServiciosPorCategoria />} />
                <Route path="categoria-servicios" element={<ServicioIndividualCate />} />
                <Route path="mi-cuenta" element={<MiCuentaAdmin />} />
                <Route path="registrar-admin" element={<RutaSoloSuperAdmin><RegistrarAdministrador /></RutaSoloSuperAdmin>} />
                <Route path="reportes-por-usuarios"   element={<RutaNoSoporte><ReportesPorUsuarios /></RutaNoSoporte>} />
                <Route path="reportes-por-servicios"  element={<RutaNoSoporte><ReportesPorServicios /></RutaNoSoporte>} />
                <Route path="reportes-por-reservas"   element={<RutaNoSoporte><ReportesPorReservas /></RutaNoSoporte>} />
                <Route path="reportes-pagos"          element={<RutaNoSoporte><ReportesPagos /></RutaNoSoporte>} />
                <Route path="reclamos" element={<Reclamos />} />
                <Route path="resenas" element={<Resenas />} />
                <Route path="reclamo"  element={<ReclamoIndividual />} />
                <Route path="busquedas" element={<Busquedas />} />
            </Route>
            </Routes>
        </>
    )

}

export default Direccionamiento;